// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const NuqsAdapter = registerClientReference(
    function() { throw new Error("Attempted to call NuqsAdapter() from the server but NuqsAdapter is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/node_modules/nuqs/dist/adapters/next/app.js",
    "NuqsAdapter",
);
